<!--
반품비용 과금 - 인라인 UI
------------------------------------
환율 입력 → 단일 POST 일괄 과금 → 완료/실패 표시
-->
<template>
    <div class="uk-card uk-card-default uk-card-body uk-card-small uk-margin-bottom">

        <!-- 대기화면: 환율 입력 (REF-015 2026-04-27 디자인 리팩토링) -->
        <div v-show="jobState === 'ready'">
            <!-- 정보 박스 그리드 -->
            <div style="display:flex;flex-wrap:wrap;border:1px solid #e0e0e0;border-radius:4px;overflow:hidden;margin-bottom:14px">
                <div style="flex:1;min-width:120px;padding:10px 16px;border-right:1px solid #e0e0e0;background:#fafafa">
                    <div class="uk-text-meta" style="font-size:1rem">과금대상</div>
                    <div class="uk-text-bold" style="font-size:1.125rem">{{ itemCount }}건</div>
                </div>
                <div style="flex:1;min-width:120px;padding:10px 16px;border-right:1px solid #e0e0e0">
                    <div class="uk-text-meta" style="font-size:1rem">반품완료일</div>
                    <div class="uk-text-bold" style="font-size:1.125rem">{{ returnDoneDate }}</div>
                </div>
                <div style="flex:1;min-width:120px;padding:10px 16px">
                    <div class="uk-text-meta" style="font-size:1rem">지역통화</div>
                    <div class="uk-text-bold" style="font-size:1.125rem">{{ regionCurrency }}</div>
                </div>
            </div>
            <!-- 환율 입력 + 과금시작 (가운데 정렬, 인접 배치) -->
            <div class="uk-flex uk-flex-center uk-flex-middle" style="gap:12px;padding:14px 0;background:#f5f9ff;border:1px solid #cfe1f5;border-radius:4px">
                <span class="uk-text-bold" style="font-size:1.125rem;color:#1565c0">적용환율</span>
                <app-input-text
                        inputSize="medium"
                        :placeholder="'1 '+regionCurrency+' to KRW'"
                        v-model.trim="regionToKrwRate"
                        style="width: 220px; display: inline-block"
                ></app-input-text>
                <button
                    class="uk-button uk-button-primary"
                    type="button"
                    style="font-size:1.05rem;padding:0 20px"
                    v-on:click="jobStart()"
                >
                    <span uk-icon="icon: play; ratio: 1"></span>
                    반품비용 과금시작
                </button>
            </div>
            <div class="uk-text-danger uk-margin-small-top" style="font-size:1rem;text-align:center">
                <i class="material-icons uk-text-middle" style="font-size: 18px">warning</i>
                환율 입력시, 타 국가의 환율을 입력하지 않도록 주의하세요!
            </div>
        </div>

        <!-- 실행중 -->
        <div v-show="jobState === 'doing'">
            <div class="uk-flex uk-flex-middle">
                <div uk-spinner="ratio: 0.6" class="uk-margin-small-right"></div>
                <span class="uk-text-primary">반품비용 과금 처리중...</span>
                <span class="uk-text-muted uk-margin-small-left">브라우저를 닫지 마세요.</span>
            </div>
        </div>

        <!-- 완료 (성공) -->
        <div v-show="jobState === 'done'">
            <div class="uk-flex uk-flex-middle uk-flex-between">
                <div class="uk-flex uk-flex-middle">
                    <i class="material-icons uk-text-middle uk-text-success" style="font-size: 28px">check_circle</i>
                    <span class="uk-text-primary uk-text-bold uk-margin-small-left">반품비용 과금이 완료되었습니다!</span>
                    <span class="uk-text-muted uk-margin-small-left">
                        (과금 {{ chargedCount }}건 / 청구서 {{ billingCount }}건)
                    </span>
                </div>
                <button
                    class="uk-button uk-button-default uk-button-small"
                    type="button"
                    @click="goToChargePage"
                >
                    <i class="material-icons uk-text-middle" style="font-size: 18px">refresh</i>
                    과금페이지로 이동
                </button>
            </div>
        </div>

        <!-- 실패 -->
        <div v-show="jobState === 'failed'">
            <div class="uk-flex uk-flex-middle uk-flex-between">
                <div class="uk-flex uk-flex-middle">
                    <i class="material-icons uk-text-middle uk-text-danger" style="font-size: 28px">error</i>
                    <span class="uk-text-danger uk-text-bold uk-margin-small-left">{{ errorMessage }}</span>
                </div>
                <button
                    class="uk-button uk-button-default uk-button-small"
                    type="button"
                    @click="refreshPage"
                >
                    <i class="material-icons uk-text-middle" style="font-size: 18px">refresh</i>
                    새로고침
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 과금 대상 건수
             */
            itemCount: {
                type: Number,
                default: 0,
            },

            // csrf-token
            csrfToken: String,
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
            /**
             * 반품완료일
             */
            returnDoneDate: {
                type: String,
                default: null,
            },
            /**
             * 지역통화
             */
            regionCurrency: {
                type: String,
                default: null,
            },

        },
        data: function () {

            return {
                // 입력한 환율
                regionToKrwRate: null,

                /**
                 * 현재 작업진행상태
                 *  - ready  : 환율 입력 대기 (초기 화면)
                 *  - doing  : 처리 중
                 *  - done   : 완료
                 *  - failed : 실패
                 */
                jobState: 'ready',

                // 결과 데이터
                chargedCount: 0,
                billingCount: 0,
                errorMessage: '과금 작업이 실패했습니다',
            };
        },
        methods: {

            // 작업시작
            jobStart: function () {

                // 환율 검증
                if (! this.regionToKrwRate) {
                    alert('환율을 입력하세요');
                    return;
                }

                // 컨펌
                if (! confirm('한번 과금되면 취소할 수 없습니다. 입력한 환율('+this.regionToKrwRate+') 이 정확합니까?')) {
                    return;
                }

                var cmp = this;
                cmp.jobState = 'doing';

                var opts = {
                    type: 'post',
                    url: '/regions/' + cmp.regionId + '/return-cost-not-charged/' + cmp.returnDoneDate + '/charge',
                    data: {
                        '_token': cmp.csrfToken,
                        'region_to_krw_rate': cmp.regionToKrwRate,
                    },
                    success: function (response) {
                        cmp.chargedCount = response.charged_count;
                        cmp.billingCount = response.billing_count;
                        cmp.jobState = 'done';
                    },
                    alert_error_msg: function (msg) {
                        cmp.errorMessage = msg;
                        cmp.jobState = 'failed';
                    },
                };
                $.app.ajax.module.default(opts);
            },

            // 현재페이지 갱신
            refreshPage: function () {
                $.app.refresh();
            },

            // 과금페이지로 이동
            goToChargePage: function () {
                $.app.move('/regions/' + this.regionId + '/return-cost-not-charged');
            },

        }
    }
</script>

<style lang="scss" scoped>
</style>
